export default __webpack_public_path__ + "static/media/section1-img4.2afdde77.png";